import React from 'react';
import { Modal } from 'react-bootstrap';
import { Clock, Ban, CheckSquare } from 'lucide-react';
import styles from './OrderTypeSelectionModal.module.scss';

export type OrderType = 'floating' | 'voided' | 'completed';

interface OrderTypeSelectionModalProps {
  show: boolean;
  onHide: () => void;
  onSelect: (type: OrderType) => void;
}

function OrderTypeSelectionModal({
  show,
  onHide,
  onSelect,
}: OrderTypeSelectionModalProps) {
  const handleSelect = (type: OrderType) => {
    onSelect(type);
    onHide();
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>View Orders</Modal.Title>
      </Modal.Header>
      <Modal.Body className={styles.modalBody}>
        <div className={styles.optionsList}>
          <button
            type="button"
            className={styles.optionItem}
            onClick={() => handleSelect('floating')}
          >
            <Clock size={24} />
            <div className={styles.optionContent}>
              <div className={styles.optionTitle}>Floating Orders</div>
              <div className={styles.optionDescription}>
                Orders saved for later
              </div>
            </div>
          </button>
          <button
            type="button"
            className={styles.optionItem}
            onClick={() => handleSelect('voided')}
          >
            <Ban size={24} />
            <div className={styles.optionContent}>
              <div className={styles.optionTitle}>Voided Orders</div>
              <div className={styles.optionDescription}>
                Cancelled or voided orders
              </div>
            </div>
          </button>
          <button
            type="button"
            className={styles.optionItem}
            onClick={() => handleSelect('completed')}
          >
            <CheckSquare size={24} />
            <div className={styles.optionContent}>
              <div className={styles.optionTitle}>Completed Orders</div>
              <div className={styles.optionDescription}>
                Successfully completed orders
              </div>
            </div>
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default OrderTypeSelectionModal;
